import { useContent } from "@/lib/content";

function LegalLayout({ title, updated, children, testid }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 lg:py-16" data-testid={testid}>
      <p className="font-tech text-xs uppercase tracking-[0.2em] text-[#B45309] mb-2">Pravno</p>
      <h1 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-[#1A1D1A]">{title}</h1>
      <p className="text-xs text-stone-400 mt-3 mb-10 font-tech">Zadnja posodobitev: {updated}</p>
      <div className="space-y-8">{children}</div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-lg font-bold text-[#1A1D1A] mb-2.5">{title}</h2>
      <div className="text-sm text-stone-600 leading-relaxed space-y-2.5">{children}</div>
    </section>
  );
}

function TextRenderer({ text }) {
  if (!text) return null;
  return (
    <div className="space-y-4">
      {text.split("\n").map((line, i) => {
        const trimmed = line.trim();
        if (!trimmed) return null;
        if (trimmed.startsWith("## ")) {
          return <h2 key={i} className="font-display text-lg font-bold text-[#1A1D1A] pt-4">{trimmed.slice(3)}</h2>;
        }
        if (trimmed.startsWith("- ")) {
          return <p key={i} className="text-sm text-stone-600 leading-relaxed pl-4">• {trimmed.slice(2)}</p>;
        }
        return <p key={i} className="text-sm text-stone-600 leading-relaxed">{trimmed}</p>;
      })}
    </div>
  );
}

export function PogojiPoslovanja() {
  const content = useContent();
  return (
    <LegalLayout title="Pogoji poslovanja" updated="30. 8. 2026" testid="pogoji-page">
      <TextRenderer text={content.pogoji_text} />
    </LegalLayout>
  );
}

export function Piskotki() {
  const content = useContent();
  return (
    <LegalLayout title="Pravilnik o piškotkih" updated="30. 8. 2026" testid="piskotki-page">
      <TextRenderer text={content.piskotki_text} />
    </LegalLayout>
  );
}

export function PravnaObvestila() {
  const content = useContent();
  return (
    <LegalLayout title="Pravna obvestila" updated="30. 8. 2026" testid="pravna-obvestila-page">
      <TextRenderer text={content.pravna_text} />
    </LegalLayout>
  );
}
